import React from 'react';
import { useParams } from 'react-router-dom';
import { PensioenbijPage } from 'app/Domain/Dashboard/Pages/Pensioenbij/PensioenbijPage';
import { EMPLOYEE_PENSIOENBIJ_COLUMNS } from 'app/Domain/Dashboard/Pages/Pensioenbij/PensioenbijMutationsTable';

export const EmployeePensioenbijTab = () => {
  const { employeeId, employerId } = useParams<{ employeeId: string; employerId: string }>();
  return (
    <PensioenbijPage
      hideEmployerFilter
      employeeId={employeeId}
      employerId={employerId}
      tableColumns={EMPLOYEE_PENSIOENBIJ_COLUMNS}
    />
  );
};
